// import { get } from 'lodash';

export default {
  getAmbassadorRegistrationInfo: (state) => state.ambassador.newRegistrationInfo,
  getAmbassadorApplicationAgreement: (state) => state.ambassador.applicationAgreement,
  getAmbassadorLeads: (state) => state.ambassador.leads,
  getAmbassdorLeadZipLookup: (state) => state.ambassador.zipLookup,
  getStripeInfo: (state) => state.ambassador.stripe,
};
